<template>
    <li>
        <div>
            <strong>
                <router-link v-if="to" :to="to">{{ title }}</router-link>
                <a
                    v-else-if="clickable"
                    href="#"
                    @click.prevent="$emit('title-click')"
                    >{{ title }}</a
                >
                <template v-else>{{ title }}</template>
                <template v-if="emoji">{{ ` ${emoji}` }}</template>
            </strong>
            <span v-for="line in lines" :key="line">{{ line }}</span>
            <slot />
            <i
                v-if="progress !== undefined"
                :style="{ '--progress': `${progress}%` }"
            />
        </div>
    </li>
</template>

<script>
export default {
    name: "MapPopupCard",
    props: {
        title: {
            type: String,
            required: true,
        },
        to: {
            type: [String, Object],
            default: null,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        lines: {
            type: Array,
            default: () => [],
        },
        emoji: {
            type: String,
            default: null,
        },
        progress: {
            type: Number,
            default: undefined,
        },
    },
    emits: ["title-click"],
};
</script>
